import { render, staticRenderFns } from "./UserPreview.vue?vue&type=template&id=5edb089a&scoped=true"
import script from "./UserPreview.vue?vue&type=script&lang=js"
export * from "./UserPreview.vue?vue&type=script&lang=js"
import style0 from "./UserPreview.vue?vue&type=style&index=0&id=5edb089a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edb089a",
  null
  
)

export default component.exports